import { setupFormState } from '@/components/form/tidal-form'

import { ChangePasswordFormValues } from './types'

export const form = setupFormState<ChangePasswordFormValues>({
  id: 'ChangePasswordUserForm',
  initialValues: {
    id: '',
    'new-password': '',
  },
})
